
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import {
  CompanyLogos,
  ResultWrapper,
  SkeletonResult,
  PopularDestinations,
  RecentSearchesWrapper,
  ConciergeTeam,
  Membership,
  GetawayList,
} from '@components';
import { SearchWrapper } from '@share/components';
import { RootState, UrlUtils, Responsive } from '@share/utils';
import { HotelsCompanyLogos } from '@common-types';
import { BackgroundColor } from '@constants';

import './style.scss';
import { GetawaysLocationEnum, ISideKickStatus } from '@share/common-types';
import { ALL_INCLUSIVE_KEY, DEAL_HOME_LABEL } from '@share/constants';


interface IProps {
  isVacationRentals?: boolean;
}

export function SearchRsi(props: IProps) {
  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);
  const benefitsStore = useSelector((state: RootState) => state.benefitsStore);

  const { isVacationRentals } = props;
  const { hotels, loading, searchedLocation, error } = hotelsStore;
  const { items } = menuStore;
  const { benefits } = benefitsStore;

  const values = UrlUtils.getValues();

  return (
    <div className="search-rsi">
      <SearchWrapper isVacationRentals={isVacationRentals} openOnClick={values[DEAL_HOME_LABEL] === ALL_INCLUSIVE_KEY} />
      
      {isEmpty(values) && !hotels && isEmpty(error) ? (
        <>
          {(benefits?.items && items?.isMLM && items?.sideKickStatus === ISideKickStatus.PARENT) ? (
            <GetawayList
              getaway={GetawaysLocationEnum.Staycation}
              condoSubcategory={null}
            
              isFromProperty
              isInternal
              isHome
              isSlider
            />) : null}

          <RecentSearchesWrapper isVacationRentals={isVacationRentals} />
          <PopularDestinations />
          <ConciergeTeam
            backgroundColor={BackgroundColor.dark}
            isImageSizeSmaller={false}
          />
          <CompanyLogos isBackgroundColorDark={false} logos={HotelsCompanyLogos} />
          <Membership />
        </>) : null}

      {hotels && loading && isEmpty(error) ? <SkeletonResult label={searchedLocation} /> : null}

      {(!isEmpty(values) && !loading && (hotels || !isEmpty(error))) ? (
        <Responsive>
          <ResultWrapper label={searchedLocation} isVacationRentals={isVacationRentals} />
        </Responsive>) : null}
    </div>
  );
}
